import { render, staticRenderFns } from "./Istoric_programari.vue?vue&type=template&id=0cdf5efb&scoped=true&"
import script from "./Istoric_programari.vue?vue&type=script&lang=js&"
export * from "./Istoric_programari.vue?vue&type=script&lang=js&"
import style0 from "./Istoric_programari.vue?vue&type=style&index=0&id=0cdf5efb&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf5efb",
  null
  
)

export default component.exports